import { Reducer } from 'redux';
import {
  EnquiryShape,
  LodgeEnquiryActionTypes,
  LodgeEnquiryState
} from './types';

export const initialState: LodgeEnquiryState = {
  shapes: [],
  enquiries: [],
  failedEnquiries: [],
  uploadedShapes: [],
  uploadedShapesUserReferences: [],
  multipleDrawMode: false,
  useUploadedShapeUserReference: false
};

const reducer: Reducer<LodgeEnquiryState> = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case LodgeEnquiryActionTypes.SET_ENQUIRY_ADDRESS: {
      const shapes = state.shapes.map((s) => {
        if (
          s.centroid.latitude === action.payload.latitude &&
          s.centroid.longitude === action.payload.longitude
        ) {
          const { address } = action.payload;
          if (
            !address?.line1 ||
            !address?.locality ||
            !address?.state ||
            !address?.postcode
          ) {
            return { ...s, address, isError: true };
          } else {
            return { ...s, address };
          }
        }
        return s;
      });
      return {
        ...state,
        shapes
      };
    }
    case LodgeEnquiryActionTypes.SET_SHAPE: {
      const theRest = state.shapes.filter((s) => s.uid !== action.payload.uid);
      const shapes = [...theRest, action.payload];
      return {
        ...state,
        shapes,
        shapeArea: shapes.reduce((a: number, s: EnquiryShape) => a + s.area, 0)
      };
    }
    case LodgeEnquiryActionTypes.SET_MULTIPLE_SHAPES: {
      const shapes = action.payload;
      return {
        ...state,
        shapes,
        shapeArea: shapes.reduce((a: number, s: EnquiryShape) => a + s.area, 0)
      };
    }
    case LodgeEnquiryActionTypes.SET_WORKING_ON_BEHALF_OF_LIST: {
      return {
        ...state,
        authorityTypeList: action.payload.authorityType,
        authorityList: action.payload.authority
      };
    }
    case LodgeEnquiryActionTypes.SET_ENQUIRY_ACT_DESIGN: {
      return {
        ...state,
        designAct: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SET_ENQUIRY_ACT_EXCAVATE: {
      return {
        ...state,
        excavationAct: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SET_EARLIEST_VALID_DATE: {
      return {
        ...state,
        earliestValidDate: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SET_LIVE_AREA: {
      return {
        ...state,
        liveArea: action.payload
      };
    }
    case LodgeEnquiryActionTypes.SET_MULTIPLE_DRAW_MODE: {
      return {
        ...state,
        multipleDrawMode: action.payload
      };
    }
    case LodgeEnquiryActionTypes.REMOVE_SHAPE: {
      const shapes = state.shapes.filter((s) => s.uid !== action.payload);
      return {
        ...state,
        shapes,
        shapeArea: shapes.reduce((a: number, s: EnquiryShape) => a + s.area, 0)
      };
    }
    case LodgeEnquiryActionTypes.CLEAR_SHAPE: {
      return {
        ...state,
        shapes: [],
        shapeArea: undefined,
        uploadedShapes: [],
        uploadedShapesUserReferences: [],
        shapeWithinTeam: undefined
      };
    }
    case LodgeEnquiryActionTypes.GET_GEOCODE_START:
      return {
        ...state,
        geocodeLoading: true
      };
    case LodgeEnquiryActionTypes.GET_GEOCODE_SUCCESS:
      return {
        ...state,
        geocodeLoading: false,
        geocodeResponse: action.payload
      };
    case LodgeEnquiryActionTypes.GET_GEOCODE_FAILURE:
      return {
        ...state,
        geocodeLoading: false,
        geocodeResponse: action.payload
      };
    case LodgeEnquiryActionTypes.GET_ENQUIRY_ESSENTIALS_START:
      return {
        ...state,
        essentialsLoading: true
      };
    case LodgeEnquiryActionTypes.GET_ENQUIRY_ESSENTIALS_SUCCESS:
      return {
        ...state,
        essentialsLoading: false
      };
    case LodgeEnquiryActionTypes.GET_ENQUIRY_ESSENTIALS_FAILURE:
      return {
        ...state,
        essentialsLoading: false
      };
    case LodgeEnquiryActionTypes.GET_ASSET_OWNERS_COUNT_START:
      return {
        ...state,
        assetOwnerNumLoading: true
      };
    case LodgeEnquiryActionTypes.GET_ASSET_OWNERS_COUNT_SUCCESS:
      return {
        ...state,
        assetOwnerNumLoading: false,
        assetOwnerNum: action.payload
      };
    case LodgeEnquiryActionTypes.GET_ASSET_OWNERS_COUNT_FAILURE:
      return {
        ...state,
        assetOwnerNumLoading: false,
        assetOwnerNum: undefined
      };
    case LodgeEnquiryActionTypes.UPLOAD_ENQUIRY_SHAPE_START:
      return {
        ...state,
        uploading: true,
        uploadedShapes: [],
        uploadedShapesUserReferences: [],
        uploadError: undefined
      };
    case LodgeEnquiryActionTypes.UPLOAD_ENQUIRY_SHAPE_SUCCESS:
      return {
        ...state,
        uploading: false,
        uploadedShapes: action.payload.geometries,
        uploadedShapesUserReferences: action.payload.userReferences
      };
    case LodgeEnquiryActionTypes.UPLOAD_ENQUIRY_SHAPE_FAILURE:
      return {
        ...state,
        uploading: false,
        uploadError: action.payload
      };
    case LodgeEnquiryActionTypes.GET_DUPLICATE_ENQUIRY_START: {
      return {
        ...state,
        duplicating: true,
        duplicateEnquiry: undefined
      };
    }
    case LodgeEnquiryActionTypes.GET_DUPLICATE_ENQUIRY_SUCCESS: {
      return {
        ...state,
        duplicating: false,
        duplicateEnquiry: action.payload
      };
    }
    case LodgeEnquiryActionTypes.GET_DUPLICATE_ENQUIRY_FAILURE: {
      return {
        ...state,
        duplicating: false,
        duplicateEnquiry: undefined
      };
    }
    case LodgeEnquiryActionTypes.CLEAR_DUPLICATE_ENQUIRY:
      return {
        ...state,
        duplicateEnquiry: {} //set to empty object to differentiate from initial state
      };
    case LodgeEnquiryActionTypes.GET_LAST_ENQUIRY_SUCCESS:
      return {
        ...state,
        lastEnquiry: action.payload
      };
    case LodgeEnquiryActionTypes.LODGE_NEW_ENQUIRY_START:
      return {
        ...state,
        lodgingNewEnquiry: true,
        lodgeEnquiryError: undefined
      };
    case LodgeEnquiryActionTypes.LODGE_NEW_ENQUIRY_SUCCESS:
      return {
        ...state,
        lodgingNewEnquiry: false,
        enquiries: action.payload,
        shapeWithinTeam: undefined
      };
    case LodgeEnquiryActionTypes.LODGE_NEW_ENQUIRY_FAILURE:
      return {
        ...state,
        lodgingNewEnquiry: false,
        lodgeEnquiryError: action.payload
      };
    case LodgeEnquiryActionTypes.SET_PENDING_ENQUIRIES_AMOUNT:
      return {
        ...state,
        pendingEnquiriesAmount: action.payload
      };
    case LodgeEnquiryActionTypes.SET_BULK_CREATING:
      return {
        ...state,
        bulkCreating: action.payload
      };
    case LodgeEnquiryActionTypes.SET_BULK_BATCH_TOTAL:
      return {
        ...state,
        bulkBatchTotal: action.payload
      };
    case LodgeEnquiryActionTypes.SET_BULK_BATCH_CREATED:
      return {
        ...state,
        bulkBatchCreated: action.payload
      };
    case LodgeEnquiryActionTypes.UPDATE_NEW_LODGED_ENQUIRIES: {
      const enquiries = state.enquiries;
      return {
        ...state,
        enquiries: [...enquiries, ...action.payload]
      };
    }
    case LodgeEnquiryActionTypes.CHECK_SHAPE_WITHIN_TEAM_START:
      return {
        ...state,
        shapeWithinTeam: 'checking'
      };
    case LodgeEnquiryActionTypes.CHECK_SHAPE_WITHIN_TEAM_SUCCESS:
      return {
        ...state,
        shapeWithinTeam: action.payload
      };
    case LodgeEnquiryActionTypes.CHECK_SHAPE_WITHIN_TEAM_FAILURE:
      return {
        ...state,
        shapeWithinTeam: undefined
      };
    case LodgeEnquiryActionTypes.USE_UPLOADED_SHAPE_USER_REFERENCE:
      return {
        ...state,
        useUploadedShapeUserReference: action.payload
      };
    case LodgeEnquiryActionTypes.CLEAR_LODGED_ENQUIRY:
      return {
        ...state,
        bulkCreating: false,
        bulkBatchCreated: undefined,
        bulkBatchTotal: undefined,
        lodgingNewEnquiry: false,
        lodgeEnquiryError: undefined,
        pendingEnquiriesAmount: undefined,
        enquiries: [],
        failedEnquiries: []
      };
    case LodgeEnquiryActionTypes.QUERY_RECENT_LAYER_EXTENT_SUCCESS:
      return {
        ...state,
        recentLayerExtent: action.payload
      };
    case LodgeEnquiryActionTypes.SET_SUCCESS_ENQUIRY_USER_REFERENCE: {
      const shapes = state.shapes.map((s) => {
        const completed = action.payload.find(
          (c: any) => c.details.mapId === s.uid
        );
        if (completed?.details?.enquiryId) {
          const enquiry = state.enquiries.find(
            (e) => e.id === completed.details.enquiryId
          );
          if (enquiry?.user_reference) {
            s.userReference = enquiry?.user_reference;
          }
        }
        return s;
      });
      return {
        ...state,
        shapes
      };
    }
    case LodgeEnquiryActionTypes.SET_MAP_ERROR_FOR_LODGE_ENQUIRY_FAIL: {
      const shapes = state.shapes.map((s) => {
        s.isFailedLodge = action.payload.includes(s.uid);
        return s;
      });
      return {
        ...state,
        shapes
      };
    }
    case LodgeEnquiryActionTypes.GET_DRAFT_START:
      return {
        ...state,
        fetchingDraft: true
      };
    case LodgeEnquiryActionTypes.GET_DRAFT_SUCCESS:
      return {
        ...state,
        fetchingDraft: false,
        duplicateEnquiry: undefined,
        draftTouched: false,
        draft: action.payload
      };
    case LodgeEnquiryActionTypes.GET_DRAFT_FAILURE:
      return {
        ...state,
        fetchingDraft: false
      };
    case LodgeEnquiryActionTypes.GET_RESTRICTIONS_START:
      return {
        ...state,
        restriction: undefined
      };
    case LodgeEnquiryActionTypes.GET_RESTRICTIONS_SUCCESS:
      return {
        ...state,
        restriction: action.payload
      };
    case LodgeEnquiryActionTypes.GET_RESTRICTIONS_FAILURE:
      return {
        ...state,
        restriction: {
          allow: false,
          total: 0,
          used: 0
        }
      };
    case LodgeEnquiryActionTypes.SAVE_DRAFT_START:
      return {
        ...state,
        savingDraft: true
      };
    case LodgeEnquiryActionTypes.SAVE_DRAFT_SUCCESS:
      return {
        ...state,
        savingDraft: false,
        draftTouched: true
      };
    case LodgeEnquiryActionTypes.SAVE_DRAFT_FAILURE:
      return {
        ...state,
        savingDraft: false
      };
    case LodgeEnquiryActionTypes.DISCARD_DRAFT_START:
      return {
        ...state,
        discardingDraft: true,
        discardedDraft: false
      };
    case LodgeEnquiryActionTypes.DISCARD_DRAFT_SUCCESS:
      return {
        ...state,
        discardingDraft: false,
        discardedDraft: true
      };
    case LodgeEnquiryActionTypes.DISCARD_DRAFT_FAILURE:
      return {
        ...state,
        discardingDraft: false
      };
    case LodgeEnquiryActionTypes.SET_FAILED_ENQUIRIES:
      return {
        ...state,
        failedEnquiries: action.payload
      };
    case LodgeEnquiryActionTypes.CLEAR_FAILED_ENQUIRIES:
      return {
        ...state,
        failedEnquiries: []
      };
    default:
      return state;
  }
};

export default reducer;
